// Pure helpers (unit-testable). JS on purpose.

export const iconMap = {
  heart: cls => IconSlot('heart', cls || 'text-pink-400'),
  region: cls => IconSlot('region', cls || 'text-cyan-400'),
  lock: cls => IconSlot('lock', cls || 'text-pink-500')
};

// Minimal placeholder that renders as a <span>. The real SVGs live in Header.jsx.
// This keeps utils free of React imports and avoids circular deps.
function IconSlot(name, className) {
  return <span data-icon={name} className={className} aria-hidden="true" />;
}

/**
 * Recursively attach icon elements and normalize children.
 * Does not mutate the original array.
 */
export function decorateNav(items, renderIcon) {
  return (items || []).map(it => ({
    ...it,
    icon: it.icon && renderIcon ? renderIcon(it.icon) : undefined,
    children: it.children ? decorateNav(it.children, renderIcon) : undefined
  }));
}